import { render, staticRenderFns } from "./bServiceView.vue?vue&type=template&id=09feb786&scoped=true"
import script from "./bServiceView.vue?vue&type=script&lang=js"
export * from "./bServiceView.vue?vue&type=script&lang=js"
import style0 from "./bServiceView.vue?vue&type=style&index=0&id=09feb786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09feb786",
  null
  
)

export default component.exports